"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationSchema = void 0;
exports.DurationSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/duration.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Duration",
    "description": "Represents the duration of a specific event or activity in ISO 8601 duration format",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:duration"
            ]
        },
        "duration": {
            "type": "string",
            "description": "The duration of the event or activity, represented in ISO 8601 duration format",
            "pattern": "^P(?=\\d|T\\d)(?:(\\d+)Y)?(?:(\\d+)M)?(?:(\\d+)([DW]))?(?:T(?:(\\d+)H)?(?:(\\d+)M)?(?:(\\d+(?:\\.\\d+)?)S)?)?$"
        }
    },
    "required": [
        "type",
        "duration"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHVyYXRpb24uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9kdXJhdGlvbi5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxjQUFjLEdBQUc7SUFDNUIsS0FBSyxFQUFFLGlFQUFpRTtJQUN4RSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxVQUFVO0lBQ25CLGFBQWEsRUFBRSxxRkFBcUY7SUFDcEcsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04scUJBQXFCO2FBQ3RCO1NBQ0Y7UUFDRCxVQUFVLEVBQUU7WUFDVixNQUFNLEVBQUUsUUFBUTtZQUNoQixhQUFhLEVBQUUsZ0ZBQWdGO1lBQy9GLFNBQVMsRUFBRSxnSEFBZ0g7U0FDNUg7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixVQUFVO0tBQ1g7Q0FDRixDQUFBIn0=